import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route} from 'react-router';

import Home from './home';

import SignOut from './auth/Signout';

import MyDay from './tasks/MyDay';
import AllTasks from './tasks/AllTasks';

import CaregiverList from './caregiver/CaregiverList';
import CaregiverNew from './caregiver/CaregiverNew';
import CaregiverView from './caregiver/CaregiverView';

import ClientList from './client/ClientList';
import ClientNew from './client/ClientNew';
import ClientView from './client/ClientView';

import ClientLeadList from './client_lead/ClientLeadList';

import ManageUser from './admin/user/ManageUser';

import CaregiverScheduleDashboardPage from './schedule/CaregiverScheduleDashboardPage';
import ClientScheduleDashboardPage from './schedule/ClientScheduleDashboardPage';

import EventDetailPage from './schedule/EventDetailPage';

import CareerDashboard from './career/CareerDashboard';
import CreateJob from './career/JobCreation';
import EditJob from './career/JobEdit';
import JobView from './career/JobView';

const Router = () => {
  return (
    <Routes>
      <Route path="/" Component={Home} />

      <Route path="/signout" Component={SignOut} />

      <Route path="/admin/user" Component={ManageUser} />
      <Route path="/admin/user/new" Component={ManageUser} />
      <Route path="/admin/user/:userRn/deactivate" Component={ManageUser} />

      <Route path="/tasks/my-day" Component={MyDay}/>
      <Route path="/tasks/all-tasks" Component={AllTasks}/>

      <Route path="/caregiver" Component={CaregiverList} />
      <Route path="/caregiver/new" Component={CaregiverNew} />
      <Route path="/caregiver/:caregiverRn" Component={CaregiverView} />

      <Route path="/client" Component={ClientList} />
      <Route path="/client/new" Component={ClientNew} />
      <Route path="/client/:clientRn" Component={ClientView} />

      <Route path="/client_lead" Component={ClientLeadList} />

      <Route path="/schedule/client" Component={ClientScheduleDashboardPage} />
      <Route path="/schedule/caregiver" Component={CaregiverScheduleDashboardPage} />
      <Route path="/schedule/event/:eventRn" Component={EventDetailPage} />

      <Route path="/career" Component={CareerDashboard} />
      <Route path="/career/create" Component={CreateJob} />
      <Route path="/career/:jobRn" Component={JobView} />
      <Route path ="/career/:jobRn/edit" Component={EditJob} />
    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

